import { useEffect } from 'react';

import { Select } from '../base/Select';
import useAppliances from '../../data/appliance/useAppliances';
import { useGraphSettings } from '../../contexts/GraphSettingsContext';

export function HardwareSelection() {
  const { appliances: allAppliances } = useAppliances();
  const { hardware, setHardware } = useGraphSettings();

  const handleApplianceChange = (value: string) => {
    let hw = allAppliances.data?.find((h) => h.id === value);

    if (!hw) {
      return;
    }

    setHardware(hw);
  };

  useEffect(() => {
    if (!allAppliances.isLoading && allAppliances.data?.length) {
      if (!hardware) {
        setHardware(allAppliances.data[0]);
      }
    }
  }, [hardware, allAppliances.isLoading, allAppliances.data, setHardware]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-11 gap-4">
      <div className="grid grid-cols-1 md:col-span-5 gap-4">
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6">
          <div className="flex items-center">
            <p className="text-sm mb-2 md:mb-0">Appliance</p>
          </div>
          <div className="md:col-span-3 lg:col-span-4">
            <Select
              className="w-full"
              value={hardware?.id ?? '0'}
              onChange={(e) => handleApplianceChange(e.currentTarget.value)}
            >
              <option value="0">Select Appliance</option>
              {allAppliances.data?.map((hardware) => (
                <option key={hardware.id} value={hardware.id}>
                  {hardware.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
}
